import { User } from 'protocol/model/dto_user_pb';

export const getUserFullName = (user: User) =>
  `${user?.PersonalData?.FirstName ?? ''} ${
    user?.PersonalData?.LastName ?? ''
  }`.trim();
